const STORAGE_KEY_SUFFIX = 'menuState';

export const MENU_EXPANDED = 'expanded';
export const MENU_COLLAPSED = 'collapsed';
export const MENU_HIDDEN = 'hidden';

export const getMenuStateStorageKey = userInfo => {
  if (!userInfo || !userInfo.current_tenant || !userInfo.username) {
    return STORAGE_KEY_SUFFIX;
  }
  return `${userInfo.current_tenant}-${userInfo.username}-${STORAGE_KEY_SUFFIX}`;
};

// Persisted shape: { state: 'expanded'|'collapsed'|'hidden', lastVisible: 'expanded'|'collapsed' }
export const saveMenuState = (userInfo, state, lastVisible) => {
  try {
    const storageKey = getMenuStateStorageKey(userInfo);
    localStorage.setItem(storageKey, JSON.stringify({state, lastVisible}));
    return true;
  } catch (error) {
    console.error('Error saving menu state:', error);
    return false;
  }
};

export const loadMenuState = userInfo => {
  try {
    const storageKey = getMenuStateStorageKey(userInfo);
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (
        [MENU_EXPANDED, MENU_COLLAPSED, MENU_HIDDEN].includes(parsed?.state)
      ) {
        return {
          state: parsed.state,
          lastVisible:
            parsed.lastVisible === MENU_COLLAPSED
              ? MENU_COLLAPSED
              : MENU_EXPANDED
        };
      }
    }
    return null;
  } catch (error) {
    console.error('Error loading menu state:', error);
    return null;
  }
};
